import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const LikesContext = createContext(null);

export function LikesProvider({ children }) {
  const { user } = useAuth();
  const [keys, setKeys] = useState(new Set());

  const uid = user ? user.id : null;
  const pid = user?.active_profile?.id;
  useEffect(() => {
    if (!uid) { setKeys(new Set()); return; }
    api.get("/likes").then((r) => setKeys(new Set(r.data.map((i) => i.place_key)))).catch(() => {});
  }, [uid, pid]);

  const toggle = async (item) => {
    const on = !keys.has(item.place_key);
    const next = new Set(keys);
    on ? next.add(item.place_key) : next.delete(item.place_key);
    setKeys(next);
    try {
      if (on) await api.post("/likes", { item });
      else await api.delete("/likes", { params: { place_key: item.place_key } });
      toast.success(on ? `Saved ${item.name} to your profile` : `Removed ${item.name}`);
    } catch (e) {
      setKeys(keys);
      toast.error(errorMessage(e));
    }
  };

  return <LikesContext.Provider value={{ keys, toggle, enabled: !!user }}>{children}</LikesContext.Provider>;
}

export const useLikes = () => useContext(LikesContext);
